import { Component, OnInit } from '@angular/core';
import { BaseDefaultListFilterComponent } from 'yt-ng-framework';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'yt-filter-only-komitent',
  templateUrl: './filter-only-komitent.component.html'
})
export class FilterOnlyKomitentComponent extends BaseDefaultListFilterComponent {

  constructor(
    protected datePipe: DatePipe
  ) {super (datePipe) }

  ngOnInit(){
    this.SetInitParameters();
}

  selectedKomitent: string = 'Svi';

  SelectKomitent(item: KomitentView){
    this.selectedKomitent = item != null ? item.Naziv + ', ' + item.Mesto : 'Svi';
}

SetFilterDescription(){
    super.SetFilterDescription();
    this.selectedKomitent = this.filterFormGroup.get('KomitentID').value ? this.selectedKomitent : 'Svi';
    this.FilterDescription = ' Komitent: ' + this.selectedKomitent;
}

SetInitParameters(){
  super.SetInitParameters();
 
  this.filterFormGroup = new FormGroup({
      KomitentID: new FormControl()
  })
}

}
